
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/hanson-and-impactoverse",
      function () {
        return require("private-next-pages/hanson-and-impactoverse/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/hanson-and-impactoverse"])
      });
    }
  